export const LmsEndpoints = {
  Loans: {
    GET: {
      LIST_LOANS: "loans/list-loans"
    }
  },
  Metadata: {
    GET: {
      LIST_BORROWER_APPLICATIONS: "metadata/list-borrower-applications",
      LIST_BORROWER_APPLICATION_INPUTS: "metadata/list-borrower-application-inputs",
      LIST_COMMENT_CATEGORIES: "metadata/list-comment-categories",
    }
  },
  Orgs: {
    GET: {
      ADDITIONAL_GUARANTOR: "orgs/additional-guarantor-info/:id",
      ADDITIONAL_GUARANTOR_ALT: "orgs/additional-guarantor-info/:id/:noRealEstate/:noAssets/:assetContactId",
      AL_SCHEDULE: "orgs/al-schedule/:id",
      BANK_INFO: "orgs/bank-info/:id",
      BANK_ACCOUNT: "orgs/bank-info/:id",
      COMMENT: "orgs/comment/:id",
      CONTACT_BUSINESS_ROLES: "orgs/contact-business-roles/:contactId",
      INSURANCE: "orgs/insurance/:id",
      REO_SCHEDULE: "orgs/reo-schedule/:id",
      STATE_TAX: "orgs/state-tax/:id",
      DOWNLOAD_DOC: "orgs/download-doc/:orgId",
      ACCOUNTS: "orgs/accounts/:orgId",
      BANK_INFO_LIST: "orgs/bank-infolist/:orgId",
      BANK_ROUTINGS: "orgs/org-bank-routings/:orgId",
      BORROWER: "orgs/borrower/:id",
      COPY: "orgs/copy/:orgId?isPayee=true",
      BORROWER_SPES: "orgs/borrower-spes",
      BROKER_LICENCES: "orgs/broker-licenses/:orgId",
      BUSINESS_ROLE: "orgs/business-roles/:contactId",
      COMMENTS: "orgs/comments/:orgId",
      CONTACT_AL_SCHEDULE: "orgs/contact-al-schedule/:contactId",
      CONTACT_ORGS: "orgs/contact-orgs?contactId=:contactId&orgId=:orgId",
      CONTACT_REO_SCHEDULE: "orgs/contact-reo-schedule/:contactId",
      CONTACTS_ORG: "orgs/contacts/:orgId",
      INSURANCES: "orgs/insurances/:orgId",
      ORG_ADDRESS: "orgs/org-address/:orgId",
      INFO_LIST: "orgs/info-list",
      BORROWERS: "orgs/org-borrowers/:orgId",
      INFO: "orgs/info/:orgId",
      SPE_BANK_INFO: "orgs/spe-bank-info/:speId",
      SPE_CONTACTS: "orgs/spe-contacts/:speId",
      SPE_COMMENTS: "orgs/spe-comments/:speId",
      ORG_TYPE: "orgs/org-type/:id/:orgId",
      SPE_ORG: "orgs/special-purose-entities/:orgId",
      SPE: "orgs/special-purose-entity/:id",
      SPE_INSURANCES: "orgs/spe-insurances/:speId",
      SPE_STATE_TAXES: "orgs/spe-state-taxes/:speId",
      STATE_TAXES: "orgs/state-taxes/:orgId",
      USER_ACCOUNT_INFO: "orgs/user-account-info/:firstName/:lastName/:email",
      ZIP_CODE_INFO: "orgs/zipcode-info/:zipCode",
      LIST_AL_CLASSES: "orgs/list-al-classes",
      LIST_AL_TYPES: "orgs/list-al-types",
      LIST_AL_STATUSES: "orgs/list-al-statuses",
      LIST_BANK_ORGS: "orgs/list-bank-orgs",
      LIST_CITIES: "orgs/list-cities/:zipCode",
      LIST_COMMENT_CATEGORIES: "orgs/list-comment-categories",
      LIST_COUNTIES: "orgs/list-counties/:zipCode",
      LIST_FUND_SIGNOR_CONTACTS: "orgs/list-fund-signor-contacts/:orgId",
      LIST_INVESTMENT_CLASSES: "orgs/list-investment-classes/:orgId/:filterInvestmentClassName",
      LIST_LOAN_ORG_CONTACTS: "orgs/list-loan-org-contacts/:orgId",
      LIST_LOAN_OFFICER_CONTACTS: "orgs/list-loan-officer-contacts",
      LIST_ORGS: "orgs/list-orgs",
      LIST_POLICES: "orgs/list-policies",
      LIST_POLICY_TYPES: "orgs/list-policy-types",
      LIST_REO_STATUSES: "orgs/list-reo-statuses",
      LIST_REO_TYPES: "orgs/list-reo-types",
      LIST_ROLES: "orgs/list-roles?orgId=:orgId&contactId=:contactId&action=:action",
      LIST_SALUTATIONS: "orgs/list-salutations",
      LIST_SPES: "orgs/list-spes",
      LIST_STATES: "orgs/list-states/:zipCode",
      LIST_USER_ORGANIZATIONS: "orgs/list-user-orgs",
      LIST_ORGANIZATION_CONTACTS: "orgs/list-contacts",
      INSURANCE_METADATA: "metadata/insurance-metadata", // Coverage Type | Provider | Provider Agent :TODO has error WI9387
      TRANSFER_METHOD: "metadata/list-wire-payment-methods", // :TODO has error WI9387,
      BANK_ROUTING: "bankaccount/bank-bankrouting/{bankId?}", // :TODO has error WI9387,
      LICENCE: "orgs/license/:licenseId"
    },
    DELETE: {
      AL_SCHEDULE: "orgs/al-schedules",
      BANK_INFO: "orgs/bank-infos",
      BORROWER_SPE: "orgs/borrower-spes",
      SPE_OR_ORG: "orgs/delete-spe-or-org/:id",
      CONTACTS: "orgs/contacts",
      BUSINESS_ROLE: "orgs/contact-business-roles",
      CONTACT_ORG: "orgs/contact-orgs",
      INSURANCE: "orgs/insurances",
      ORGS: "orgs/orgs",
      REO_SCHEDULE: "orgs/reo-schedules",
      STATE_TAX: "orgs/state-taxes",
      LICENCE: "orgs/licenses"
    },
    POST: {
      ORG: "orgs/add",
      CONTACT_ORG: "orgs/contact-org",
      SPE: "orgs/spe",
      AL_SCHEDULE: "orgs/al-schedule",
      BANK_INFO: "orgs/bank-info",
      COMMENT: "orgs/comment",
      CONTACT_BUSINESS_ROLES: "orgs/contact-business-roles?organizatinContactId=:id",
      INSURANCE: "orgs/insurance",
      REO_SCHEDULE: "orgs/reo-schedule",
      STATE_TAX: "orgs/state-tax",
      LICENCE: "orgs/license"
    },
    PUT: {
      ORG: "orgs/update",
      SPE: "orgs/spe", // TODO: It is missing WI9758
      ADDITIONAL_GUARANTOR_INFO: "orgs/update-additional-guarantor-info",
      AL_SCHEDULE: "orgs/update-al-schedule",
      BANK_INFO: "orgs/update-bank-info",
      UPDATE_INSURANCE: "orgs/update-insurance",
      DEACTIVATE_SPA: "orgs/deacivate-spe/:id",
      REO_SCHEDULE: "orgs/update-reo-schedule",
      STATE_TAX: "orgs/update-state-tax"
    }
  }
};